import { apiJson } from "@/lib/api";

export type DevLoginUser = {
  id: string;
  displayName: string;
  profileSetupComplete?: boolean;
};

/** Dev / offline guest session — same contract as `POST /dev/login` with `{ guest: true }`. */
export async function guestDevLogin(): Promise<{
  token: string;
  user: DevLoginUser;
}> {
  return apiJson<{ token: string; user: DevLoginUser }>("/dev/login", {
    method: "POST",
    body: JSON.stringify({ guest: true }),
  });
}
